module.exports = __webpack_public_path__ + "img/02.389a6112.svg";